import { Config, State } from "../types"
import { tryLoadStateFromLocalStorage } from "./local_storage"

const BASE_STATE: Omit<State, "designations"> = {
  focusedPane: "left",
  focusedDesignationIndex: -1,
  frequency: { type: "once" },
  editFrequencyExpanded: false,
  errors: {},
  savePaymentMethodChecked: true,
  feeCovered: false,
  liveValidate: false,
  formReady: false,
  memoChecked: false,
  memoText: "",
}

type ConfigForInitializeState = Pick<
  Config,
  "default_frequency" | "default_amount"
> & {
  default_fund: Pick<Config["default_fund"], "id">
}

export function initializeState(config: ConfigForInitializeState): State {
  const amount = config.default_amount || ""
  const defaultState = {
    ...BASE_STATE,
    designations: [{ fundId: config.default_fund.id, amount }],
  }

  if (config.default_frequency) {
    defaultState.frequency = config.default_frequency
  }

  return tryLoadStateFromLocalStorage() || defaultState
}
